import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {ContractsComponent} from './contracts.component';
import {CreateContractComponent} from './create-contract/create-contract.component';
import {ViewContractComponents} from './view-contract/view-contract.components';
import {ListContractsComponent} from './list-contracts/list-contracts.component';
import {EditContractComponent} from './edit-contract/edit-contract.component';

const contractRoute: Routes = [
    {
        path: '',
        component: ContractsComponent,
        children: [
            {
                path: 'adauga-contract',
                component: CreateContractComponent
            },
            {
                path: 'contract/:id',
                component: ViewContractComponents
            },
            {
                path: 'editare-contract/:id',
                component: EditContractComponent
            },
            {
                path: 'lista-contracte',
                component: ListContractsComponent
            },
            { path: '', redirectTo: '/', pathMatch: 'full' },
            {
                path: '**',
                redirectTo: '/',
                pathMatch: 'full',
            }
        ]
    }
]

@NgModule({
    imports: [RouterModule.forChild(contractRoute)],
    exports: [RouterModule]
})
export class ContractsRoutingModule {
}
